import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/common/Layout";
import ApiReference from "../components/developer/ApiReference";
import WebhookReference from "../components/developer/WebhookReference";
import TryPanel from "../components/developer/TryPanel";
import LoadingSpinner from "../components/common/LoadingSpinner";
import "../styles/DeveloperPortal.css";

const API_URL = process.env.REACT_APP_API_URL || "/api";

function DeveloperPortalPage() {
  const [loading, setLoading] = useState(true);
  const [apiInfo, setApiInfo] = useState(null);
  const [schema, setSchema] = useState(null);
  const [error, setError] = useState("");
  const [tab, setTab] = useState("api");

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      axios.get(`${API_URL}/docs`).then((r) => r.data),
      axios.get(`${API_URL}/docs/schema`).then((r) => r.data),
    ])
      .then(([info, sch]) => {
        if (cancelled) return;
        setApiInfo(info);
        setSchema(sch);
      })
      .catch((e) => {
        if (!cancelled) setError(e?.response?.data?.error || "Failed to load docs");
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <LoadingSpinner message="Loading developer docs..." />;

  return (
    <Layout title="Developer Portal" subtitle="API and webhook reference">
      <div className="developer-portal">
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        )}

        <div className="developer-tabs">
          <button
            className={`developer-tab ${tab === "api" ? "active" : ""}`}
            onClick={() => setTab("api")}
          >
            <i className="fas fa-book" /> API Reference
          </button>
          <button
            className={`developer-tab ${tab === "webhooks" ? "active" : ""}`}
            onClick={() => setTab("webhooks")}
          >
            <i className="fas fa-satellite-dish" /> Webhooks
          </button>
          <button
            className={`developer-tab ${tab === "try" ? "active" : ""}`}
            onClick={() => setTab("try")}
          >
            <i className="fas fa-flask" /> Try It
          </button>
        </div>

        <div className="developer-content">
          {tab === "api" && <ApiReference apiInfo={apiInfo} schema={schema} />}
          {tab === "webhooks" && <WebhookReference apiInfo={apiInfo} />}
          {tab === "try" && <TryPanel apiInfo={apiInfo} />}
        </div>
      </div>
    </Layout>
  );
}

export default DeveloperPortalPage;